import { memo } from 'react';

import { cn } from '@/lib/utils';

export interface LoadingSpinnerProps {
  /** Size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Container height class */
  containerHeight?: string;
  /** Additional className */
  className?: string;
  /** Show as full page overlay */
  fullPage?: boolean;
}

const SIZE_MAP = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-4',
  lg: 'h-12 w-12 border-4',
} as const;

export const LoadingSpinner = memo(function LoadingSpinner({
  size = 'md',
  containerHeight = 'h-64',
  className,
  fullPage = false,
}: LoadingSpinnerProps) {
  const spinnerClass = cn(
    'animate-spin rounded-full border-border border-t-primary',
    SIZE_MAP[size],
    className,
  );

  if (fullPage) {
    return (
      <div className="flex-center bg-background/80 fixed inset-0 z-50">
        <div className={spinnerClass} />
      </div>
    );
  }

  return (
    <div className={cn('flex-center', containerHeight)}>
      <div className={spinnerClass} />
    </div>
  );
});

export default LoadingSpinner;
